import { useEffect, useRef } from 'react';
import { parseFedRoute, goFedRoute } from './deeplink';

export function useFedHistory(route, { tourId, articleId, projectId, messengerId }) {
  const historyReady = useRef(false);
  useEffect(() => {
    const restore = () => {
      const raw = window.location.hash.slice(1)
        || window.location.pathname.replace(/^\/+|\/+$/g, '');
      goFedRoute(parseFedRoute(raw) || { target: raw ? 'notfound' : 'home' });
    };
    window.addEventListener('popstate', restore);
    return () => {
      window.removeEventListener('popstate', restore);
      historyReady.current = false;
    };
  }, []);

  useEffect(() => {
    if (!historyReady.current) {
      historyReady.current = true;
      window.history.replaceState({ ...window.history.state, fedDepth: 0 }, '');
      return;
    }
    let seg = route;
    if (route === 'tournament' && tourId) seg = `tournament/${encodeURIComponent(tourId)}`;
    else if (route === 'article' && articleId) seg = `article/${encodeURIComponent(articleId)}`;
    else if (route === 'project' && projectId) seg = `project/${encodeURIComponent(projectId)}`;
    else if (route === 'messenger' && messengerId) seg = `messenger/${encodeURIComponent(messengerId)}`;
    const url = route === 'home' ? '/' : '/#' + seg;
    if (window.location.pathname + window.location.hash === url) return;
    window.history.pushState({ fedDepth: (window.history.state?.fedDepth || 0) + 1 }, '', url);
  }, [route, tourId, articleId, projectId, messengerId]);
}
